export const TERMINATION_STATUSES = [
  'requested',
  'counter_proposed',
  'accepted_by_tenant',
  'accepted_by_landlord',
  'mutual_acceptance_reached',
  'rejected',
  'withdrawn',
  'expired'
];

export const TERMINATION_STATUS_LABELS = {
  requested: 'In behandeling',
  counter_proposed: 'Tegenvoorstel ontvangen',
  accepted_by_tenant: 'Wachten op akkoord van verhuurder',
  accepted_by_landlord: 'Wachten op akkoord van huurder',
  mutual_acceptance_reached: 'Akkoord bereikt (door beide partijen)',
  rejected: 'Afgewezen',
  withdrawn: 'Ingetrokken',
  expired: 'Verlopen'
};

export const TERMINATION_STATUS_STYLES = {
  requested: 'bg-blue-100 text-blue-700',
  counter_proposed: 'bg-amber-100 text-amber-700',
  accepted_by_tenant: 'bg-indigo-100 text-indigo-700',
  accepted_by_landlord: 'bg-indigo-100 text-indigo-700',
  mutual_acceptance_reached: 'bg-green-100 text-green-700',
  rejected: 'bg-red-100 text-red-700',
  withdrawn: 'bg-gray-100 text-gray-700',
  expired: 'bg-gray-100 text-gray-600'
};

export const TERMINATION_DISCLAIMER =
  'StudyStay faciliteert communicatie en documentatie. De beëindiging is alleen geldig volgens de afspraken in het contract en de toepasselijke wetgeving.';

export const TERMINATION_REASON_OPTIONS = {
  tenant: [
    { value: 'end_of_term', label: 'Einde contractperiode' },
    { value: 'early_termination', label: 'Vroegtijdige beëindiging' },
    { value: 'study_stopped', label: 'Studie stopgezet' },
    { value: 'financial_issue', label: 'Financiële redenen' },
    { value: 'conflict', label: 'Conflict' },
    { value: 'other', label: 'Andere reden' }
  ],
  landlord: [
    { value: 'non_payment', label: 'Wanbetaling' },
    { value: 'nuisance', label: 'Overlast' },
    { value: 'own_use', label: 'Eigen gebruik' },
    { value: 'renovation', label: 'Renovatie' },
    { value: 'other', label: 'Andere reden' }
  ]
};

export const CONTRACT_TYPE_OPTIONS = [
  { value: 'student', label: 'Studentenhuurcontract' },
  { value: 'residential', label: 'Woninghuurcontract' },
  { value: 'temporary', label: 'Tijdelijk huurcontract' },
  { value: 'other', label: 'Ander type' }
];

export const COUNTRY_OPTIONS = [
  { value: 'BE', label: 'België' },
  { value: 'NL', label: 'Nederland' }
];

export function formatDate(value) {
  if (!value) return 'N/B';
  if (value.seconds) {
    return new Date(value.seconds * 1000).toLocaleDateString('nl-NL');
  }
  return new Date(value).toLocaleDateString('nl-NL');
}
